"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { api } from "@/lib/client";
import { FormError } from "@/components/Modal";
import { Field, buttonClass, inputClass } from "@/components/ui";

export function LoginForm({ nextPath }: { nextPath?: string }) {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const result = await api.post("/api/auth/login", { email, password });
    if (!result.ok) {
      setError(result.error);
      setLoading(false);
      return;
    }
    const target = nextPath && nextPath.startsWith("/") ? nextPath : "/dashboard";
    if (target.startsWith("/api/")) {
      // API 라우트는 페이지가 아니라서 클라이언트 라우팅으로는 못 간다(RSC 응답을 기대하다 깨진다).
      // 리다이렉트를 돌려주는 엔드포인트(예: /api/sso/pmai)로 갈 때는 실제 이동을 시킨다.
      window.location.assign(target);
      return;
    }
    router.replace(target);
    router.refresh();
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <Field label="이메일" required>
        <input
          type="email"
          className={inputClass}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="name@chloe-soft.com"
          autoComplete="username"
          required
        />
      </Field>
      <Field label="비밀번호" required>
        <input
          type="password"
          className={inputClass}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
      </Field>
      <FormError message={error} />
      <button type="submit" className={`${buttonClass.primary} w-full`} disabled={loading}>
        {loading ? "로그인 중..." : "로그인"}
      </button>
    </form>
  );
}
